/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useRef, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  VegaFlex,
  VegaCard,
  VegaFont,
  VegaGrid,
  VegaIcon,
  VegaBox,
  VegaChip,
  VegaImageUploader,
  VegaButton,
  VegaInput,
  VegaForm,
  VegaButtonLink,
  VegaButtonCircle,
  VegaInputSelect,
  VegaModal
} from '@heartlandone/vega-react';
import PropTypes from 'prop-types';
import { useKeycloak } from '@react-keycloak/web';
import { blob2Base64, zoomImage, setAllUserAvatar } from 'Chores/utils';
import { updateUserInfoAvatar, createUserInfoAvatar, updateUserRoleDelete, getUserRoles, getProjectRoles } from 'Chores/request';
import './UserProfile.scss';
import { getUserInfoAvatar, getUserInfos, getAllProject } from 'Chores/request';
import UserProfileAddAndUpdateAccessPermissionModal from './UserProfileAddAndUpdateAccessPermissionModal';
import UserProfileUpdateBusinessInformationModal from './UserProfileUpdateBusinessInformationModal';
import { getFromlocalStorage } from 'Chores/utils';
import { MODULE_ROLE_PROJECT_ID } from 'Chores/Constants';
import { arr2vegaSelectSource, arr2ParentChildObj } from 'Chores/utils';

const UserProfile = ({ loadUserInfoAvatar = () => { }, isRedirect = false }) => {
  const { keycloak } = useKeycloak();
  const userAvatarUploadRef = useRef();
  const formRef = useRef();
  const [phone, setPhone] = useState('');
  const [nativeName, setNativeName] = useState('');
  const [secondaryEmail, setSecondaryEmail] = useState('');
  const [managerId, setManagerId] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [isRefresh, setIsRefresh] = useState(isRedirect);
  const defaultAvatar = 'data:image/png;base64,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';
  const [userAvatar, setUserAvatar] = useState({
    url: defaultAvatar,
    name: 'User Image'
  });
  const [userInfo, setUserInfo] = useState({
    id: '',
    userId: '',
    name: '',
    phone: '',
    email: '',
    avatar: '',
    nativeName: ''
  });
  const [isEditingUserInfo, setIsEditingUserInfo] = useState(false);
  const [isSubmitInvalid, setIsSubmitInvalid] = useState(false);
  const [isProfileReady, setIsProfileReady] = useState(false);
  const [addAndUpdateModal, setAddAndUpdateModal] = useState(false);
  const [openUpdateBusinessInformationModal, setOpenUpdateBusinessInformationModal] = useState(false);

  const [searchParams] = useSearchParams();
  const userId = searchParams.get('id');
  const disableEdit = searchParams.get('isEdit') === 'false' ? true : false;

  const [projects, setProjects] = useState([]);
  const [projectAlls, setProjectAlls] = useState([]);
  const [scrumTeams, setScrumTeams] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userAllocations, setUserAllocations] = useState([]);
  const [projectRolesDataSource, setProjectRolesDataSource] = useState({});
  const [projectRolePermissions, setProjectRolePermissions] = useState([]);
  const [businessTitleSource, setBusinessTitleSource] = useState([]);
  const [titleId, setTitleId] = useState('');
  const [positionCategories, setPositionCategories] = useState([]);
  const [positionCategoryId, setPositionCategoryId] = useState('');
  const [role, setRole] = useState([]);
  const [roleId, setRoleId] = useState('');
  const [accessPermissionConfirmModel, setAccessPermissionConfirmModel] = useState(false);
  const [accessPermissionItem, setAccessPermissionItem] = useState({});
  const [allRoles, setAllRoles] = useState([]);
  const [deletePermissionDisabled, setDeletePermissionDisabled] = useState(false);

  useEffect(() => {
    getAllProject().then((res) => {
      setProjectAlls(res.allProjects.map((i) => ({ id: i.projectId, displayName: i.projectName, companyDictDataId: i.companyDictDataId, marketCodeId: i.marketCodeDictDataId })));
      setProjects(res.allProjects.filter((x) => x.isActive).sort((a, b) => a.projectName.localeCompare(b.projectName)).map((i) => ({ id: i.projectId, displayName: i.projectName, companyDictDataId: i.companyDictDataId, marketCodeId: i.marketCodeDictDataId })));
    });
    getUserInfos().then((res) => {
      const scrumTeamList = res.scrumTeams.map((item) => ({ id: item.id, displayName: item.scrumTeamName, projectId: item.projectId }));
      setScrumTeams(scrumTeamList);
      const users = res.userInfos.filter((i) => i.userId !== userId).map((i) => ({ id: i.userId, displayName: i.name })).filter((i) => !!i.displayName);
      setUserList(users);
      setRole(res.roles.map((i) => ({ id: i.id, displayName: i.name })));
      setPositionCategories(res.positionCategories.map((i) => ({ id: i.id, displayName: i.name })));
    });

    const marketCode = getFromlocalStorage('allDictType');
    const marketCodelist = marketCode.find((i) => i.name === 'Business Title').dictData;
    setBusinessTitleSource(marketCodelist?.map((i) => ({ id: i.id, displayName: i.name })));
    fetchUserRolePermission();
  }, []);

  useEffect(() => {
    let mounted = true;
    let intervalId = null;
    let timeoutId = null;
    let observer = null;

    const getHost = () => document.querySelector('#user-information-container')?.querySelector('#user-upload-avatar');

    const checkReady = () => {
      const pageLoaded = document.readyState === 'complete';
      const host = getHost();
      const innerReady = !!(host && host.shadowRoot && host.shadowRoot.querySelector('.vega-image-uploader-select img'));
      return pageLoaded && innerReady;
    };

    const markReady = () => {
      if (!mounted) return;
      setIsProfileReady(true);
    };

    const startPolling = () => {
      if (intervalId) return;
      intervalId = setInterval(() => {
        if (checkReady()) {
          clearInterval(intervalId);
          intervalId = null;
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          markReady();
        }
      }, 250);
      timeoutId = setTimeout(() => {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }, 15000);
    };

    const startObservingContainer = () => {
      const container = document.querySelector('#user-information-container') || document.body;
      observer = new MutationObserver(() => {
        const host = getHost();
        if (host && host.shadowRoot) {
          try {
            observer.disconnect();
          } catch (e) { }
          observer = new MutationObserver(() => {
            if (checkReady()) {
              if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
              }
              if (observer) {
                observer.disconnect();
                observer = null;
              }
              markReady();
            }
          });
          try {
            observer.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true });
          } catch (e) { }
        }
      });
      observer.observe(container, { childList: true, subtree: true });
    };

    const onLoaded = () => {
      if (checkReady()) {
        markReady();
        return;
      }
      startPolling();
      startObservingContainer();
    };

    if (document.readyState === 'complete') {
      setTimeout(onLoaded, 200);
    } else {
      window.addEventListener('load', onLoaded);
    }

    return () => {
      mounted = false;
      window.removeEventListener('load', onLoaded);
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
      if (observer) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isRefresh) {
      setIsRefresh(true);
      const leftNavGroup = document.querySelectorAll('vega-left-nav vega-left-nav-group');
      leftNavGroup?.forEach((item) => item.shadowRoot?.firstChild.classList.remove('open'));
    };
  }, [isRefresh]);

  useEffect(() => {
    if (isProfileReady) {
      judgeUI();
    }
  }, [isProfileReady]);

  useEffect(() => {
    if (keycloak?.idTokenParsed?.sub !== undefined) {
      loadUserInfo();
    }
  }, [keycloak?.idTokenParsed]);

  useEffect(() => {
    setPhone(userInfo?.phone ? userInfo.phone.trim() : '');
    setNativeName(userInfo?.nativeName ? userInfo.nativeName.trim() : '');
    setSecondaryEmail(userInfo?.secondaryEmail ? userInfo.secondaryEmail.trim() : '');
    setManagerId(userInfo?.managerId);
    setTitleId(userInfo?.titleId);
    setPositionCategoryId(userInfo?.positionCategoryId);
    setRoleId(userInfo?.roleId);
    setEmployeeId(userInfo?.employeeId);
    resetUserIcon();
    setIsEditingUserInfo(false);
    setIsSubmitInvalid(false);
    setUserAllocations(userInfo?.userAllocations);
  }, [userInfo]);

  useEffect(() => {
     const contol = document.querySelector('#user-information-container')?.querySelector('#user-upload-avatar');
      if (contol && contol.shadowRoot) {
        const img = contol.shadowRoot.querySelector('.vega-image-uploader-select img');
        if (img) {
          if (isEditingUserInfo) {
            img.style.borderRadius = '12px';
            img.style.objectFit = 'fill';
          } else {
            img.style.borderRadius = '50%';
            img.style.objectFit = 'fill';
          }
        }
      }
  }, [isEditingUserInfo]);

  const judgeUI = () => {
    const timer = setTimeout(() => {
      const contol = document.querySelector('#user-information-container')?.querySelector('#user-upload-avatar');
      if (contol && contol.shadowRoot) {
        const select = contol.shadowRoot.querySelectorAll('.vega-image-uploader-select');
        select.forEach((item) => {
          item.style.border = 'none';
          item.style.background = 'none';
          item.style.backgroundColor = 'transparent';
          item.style.borderRadius = '50%';
        });

        const img = contol.shadowRoot.querySelector('.vega-image-uploader-select img');
        if (img) {
          img.style.borderRadius = '50%';
          img.style.objectFit = 'fill';
        }
      }
      clearTimeout(timer);
    }, 500);
  };

  const resetUserIcon = () => {
    judgeUI();
    if (userInfo.avatar === null || userInfo.avatar === '') {
      setUserAvatar({
        url: defaultAvatar,
        name: 'User Image'
      });
    } else if (userInfo.avatar !== userAvatar.url || userAvatar instanceof File) {
      setUserAvatar({
        url: userInfo.avatar,
        name: 'User Image'
      });
    }
  };

  const loadUserInfo = () => {
    const loadId = VegaLoader.load();
    getUserInfoAvatar(userId ? userId : keycloak.idTokenParsed.sub).then((res) => {
      VegaLoader.close(loadId);
      if (!res.name || res.name.trim() === '') {
        res.name = emailConvertLabel(keycloak?.idTokenParsed?.email);
      }
      setUserInfo(res);
    });
  };

  const saveCompleted = (avatar, loadId) => {
    VegaLoader.close(loadId);
    userInfo.avatar = avatar;
    userInfo.phone = phone.trim();
    userInfo.nativeName = nativeName.trim();
    userInfo.secondaryEmail = secondaryEmail.trim();
    userInfo.managerId = managerId;
    userInfo.roleId = roleId;
    userInfo.titleId = titleId;
    userInfo.positionCategoryId = positionCategoryId;
    userInfo.employeeId = employeeId;
    userInfo.managerName = userList.find((i) => i.id === managerId)?.displayName;
    setUserInfo({ ...userInfo });

    setAllUserAvatar();
    window.dispatchEvent(new Event('refreshUserInfoAvatar'));
    setIsSubmitInvalid(false);
    setIsEditingUserInfo(false);
  };

  const callbackByZoomImage = (avatar) => {
    const _userInfo = {
      id: userInfo?.id,
      userId: userInfo?.userId,
      roleId: roleId,
      titleId: titleId,
      positionCategoryId: positionCategoryId,
      phone: phone.trim(),
      avatar: avatar,
      nativeName: nativeName.trim(),
      secondaryEmail: secondaryEmail.trim(),
      managerId: managerId,
      employeeId: employeeId
    };

    const loadId = VegaLoader.load();
    if (userInfo.hasSet) {
      updateUserInfoAvatar(_userInfo).then((res) => {
        saveCompleted(avatar, loadId);
      }).catch((error) => {
        VegaLoader.close(loadId);
      });
    } else {
      createUserInfoAvatar(_userInfo).then((res) => {
        saveCompleted(avatar, loadId);
      }).catch((error) => {
        VegaLoader.close(loadId);
      });
    }
  };

  const _onSave = async () => {
    if (userAvatarUploadRef.current && userAvatarUploadRef.current.value instanceof File && userAvatarUploadRef.current.value !== null) {
      const base64Image = await blob2Base64(userAvatarUploadRef.current.value.slice());
      zoomImage(base64Image, 100, callbackByZoomImage, 0.9);
    } else {
      callbackByZoomImage(userInfo.avatar);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const validatePhone = (phoneStr) => {
    if (!phoneStr) return false;
    const trimmed = phoneStr.trim();
    if (!/^[+\d\s\-().]+$/.test(trimmed)) return false;
    const hasPlus = trimmed.startsWith('+');
    const digitsOnly = trimmed.replace(/[^\d]/g, '');
    return digitsOnly.length >= 7 && digitsOnly.length <= 15 && (!hasPlus || /^\+\d{1,15}$/.test('+' + digitsOnly));
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const phoneNumberValidationRule = {
    overrideDefault: true,
    canEvaluate(input, status) {
      return input !== '';
    },
    evaluate: (input) => {
      const isValid = validatePhone(input);
      return { isValid, message: isValid ? '' : 'Please enter a valid phone number.' };
    }
  };

  const goBack = () => {
    window.history.back();
  };

  const openAddAndUpdateAccessPermissionModal = (item) => {
    setAccessPermissionItem(item);
    setAddAndUpdateModal(true);
    loadUserInfo();
  };

  const closeAddAndUpdateAccessPermissionModal = () => {
    setAddAndUpdateModal(false);
  };

  const openAccessPermissionConfrimModal = (item) => {
    setAccessPermissionItem(item);
    setAccessPermissionConfirmModel(true);
  };

  const closeAccessPermissionConfrimModal = () => {
    setAccessPermissionConfirmModel(false);
    setAccessPermissionItem({});
  };

  const deleteAccessPermission = () => {
    setDeletePermissionDisabled(true);
    const params = {
      'userId': [
        userId
      ],
      'moduleRole': [
      ],
      'projectRole': [
        {
          'projectId': accessPermissionItem.projectId,
          'roleId': accessPermissionItem.roleId
        }
      ]
    };

    updateUserRoleDelete(params).then((res) => {
      fetchUserRolePermission();
      closeAccessPermissionConfrimModal();
      VegaNotify.open({
        type: 'success',
        message: 'The permission has been deleted.'
      });
    })
      .catch((error) => {
        VegaNotify.open({
          type: 'error',
          message: 'The permission could not be deleted.'
        });
      })
      .finally(() => {
        setDeletePermissionDisabled(false);
      });
  };

  const showUpdateBusinessInformationModal = () => {
    setOpenUpdateBusinessInformationModal(true);
  };

  const closeUpdateBusinessInformationModal = () => {
    setOpenUpdateBusinessInformationModal(false);
  };

  const onChangeManagerId = (managerId) => {
    if (managerId) {
      setManagerId(managerId);
    }
  };

  const onChangeRoleId = (roleId) => {
    if (roleId) {
      setRoleId(roleId);
    }
  };

  const onChangeTitleId = (titleId) => {
    if (titleId) {
      setTitleId(titleId);
    }
  };

  const onChangePositionCategoryId = (positionCategoryId) => {
    if (positionCategoryId) {
      setPositionCategoryId(positionCategoryId);
    }
  };

  const fetchUserRolePermission = () => {
    const params = {
      userId: userId
    };

    const paramsByProjectRoles = {
      MaxResultCount: 1000
    };

    Promise.all([getUserRoles(params), getProjectRoles(paramsByProjectRoles)]).then((res) => {
      const [userRoles, projectRolesRes] = res;
      setAllRoles(userRoles.roles);

      const userSelectProjectRoles = userRoles.selectedRoles
        .filter((item) => item.projectId !== MODULE_ROLE_PROJECT_ID)
        .sort((a, b) => {
          const firstCreation = new Date(a.creationTime || 0).getTime();
          const secondCreation = new Date(b.creationTime || 0).getTime();
          if (firstCreation !== secondCreation) {
            return secondCreation - firstCreation;
          }

          const firstProject = String(a.projectId ?? '');
          const secondProject = String(b.projectId ?? '');
          return secondProject.localeCompare(firstProject);
        });
      setProjectRolePermissions(userSelectProjectRoles);

      const projectRoles = projectRolesRes.items;
      projectRoles.forEach((pr) => {
        const r = userRoles.roles.find((r) => r.id === pr.roleId);
        if (r) {
          pr.roleName = r.name;
        }
      });

      const projectRolesByProjectId = arr2ParentChildObj(projectRoles, 'projectId');
      const vagaSourceProjectRoles = {};
      for (const key in projectRolesByProjectId) {
        if (Object.hasOwnProperty.call(projectRolesByProjectId, key)) {
          vagaSourceProjectRoles[key] = arr2vegaSelectSource(projectRolesByProjectId[key], 'roleId', 'roleName');
        }
      }

      setProjectRolesDataSource(vagaSourceProjectRoles);
    });
  };

  const mapemployeeTypeOptions = ['', 'FTE', 'CWE', 'External'];

  const getRoleName = (roleId) => {
    const role = allRoles.filter((item) => {
      return item.id === roleId;
    });

    if (role.length > 0) {
      return role[0].name;
    }
  };

  return (
    <>
      <VegaFlex
        className='user-profile'
        direction='col'
        alignItems='stretch'
        justifyContent='start'
        gap='size-16'
      >
        <VegaFlex>
          <VegaButtonLink icon="fas fa-angle-left" onVegaClick={goBack}>
            Back
          </VegaButtonLink>
        </VegaFlex>
        <VegaCard
          padding='size-24'
          backgroundColor='bg-primary'
          id='user-information-container'
          borderColor='border-secondary'
        >
          <VegaFlex
            direction='col'
            alignItems='stretch'
            justifyContent='start'
            gap='size-24'
          >
            <VegaFlex
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              gap='size-24'
            >
              <VegaFlex
                direction='row'
                alignItems='center'
                justifyContent='start'
                gap='size-24'
                style={{ witdh: '100px' }}
              >
                <VegaImageUploader
                  id="user-upload-avatar"
                  ref={userAvatarUploadRef}
                  value={userAvatar}
                  borderColor='none'
                  style={{ borderWidth: 0, borderRadius: '50%', display: userInfo?.id === '' ? 'none' : 'block' }}
                  showPreviewButton={false}
                  showRemoveButton={false}
                  showReplaceButton={isEditingUserInfo}
                  onVegaChange={(e) => {
                    setUserAvatar(e.target.value);
                  }}
                ></VegaImageUploader>
                <img alt="User Avatar" style={{ width: '120px', height: '120px', display: userInfo?.id === '' ? 'block' : 'none' }} src={userAvatar.url}>
                </img>
                <VegaFlex
                  id='user-info-readonly'
                  direction='col'
                  alignItems='stretch'
                  justifyContent='center'
                  gap='size-12'
                  style={{
                    display: isEditingUserInfo ? 'none' : 'flex',
                    minWidth: '70%'
                  }}
                >
                  <VegaFont
                    color='text-primary'
                    variant='font-h5'
                    style={{ verticalAlign: 'top', alignSelf: 'stretch' }}
                  >
                    {userInfo?.name ?? ''}{userInfo?.nativeName ? '(' + userInfo?.nativeName + ')' : ''}
                  </VegaFont>
                  <VegaGrid
                    gap='size-20'
                    column='3-auto'
                    row='3-auto'
                  >
                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-map-marked-alt'
                        color='text-secondary'
                      ></VegaIcon>
                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Location
                        </VegaFont>
                        <VegaFont
                          color='text-primary'
                          variant='font-p2-short'
                          style={{
                            display: 'block',
                            verticalAlign: 'bottom',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          { userInfo?.locationName ?? '' }
                        </VegaFont>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-phone'
                        color='text-secondary'
                      ></VegaIcon>
                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Phone
                        </VegaFont>
                        <VegaFont
                          color='text-primary'
                          variant='font-p2-short'
                          style={{
                            display: 'block',
                            verticalAlign: 'bottom',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          { phone }
                        </VegaFont>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-id-card-clip'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Employee ID
                        </VegaFont>

                        <VegaFont
                          color='text-primary'
                          variant='font-p2-short'
                          style={{
                            verticalAlign: 'bottom',
                            alignSelf: 'stretch'
                          }}
                        >
                          { employeeId }
                        </VegaFont>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-at'
                        color='text-secondary'
                      ></VegaIcon>
                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Primary Email
                        </VegaFont>
                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { userInfo?.email ?? ''}
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-at'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Secondary Email
                        </VegaFont>

                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { secondaryEmail }
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-people-roof'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Line Manager
                        </VegaFont>

                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { userInfo.managerName }
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-user-large'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Project Role
                        </VegaFont>

                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { role.find((i) => userInfo.roleId === i.id)?.displayName ?? '' }
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-screen-users'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Position Classification
                        </VegaFont>

                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { positionCategories.find((i) => userInfo.positionCategoryId === i.id)?.displayName ?? '' }
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>

                    <VegaFlex
                      direction='row'
                      alignItems='start'
                      justifyContent='start'
                      gap='size-12'
                    >
                      <VegaIcon
                        size='size-16'
                        icon='far fa-id-card'
                        color='text-secondary'
                      ></VegaIcon>

                      <VegaFlex
                        direction='col'
                        alignItems='stretch'
                        justifyContent='center'
                        gap='size-8'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-field-label-sm'
                          style={{
                            display: 'block',
                            verticalAlign: 'middle',
                            alignSelf: 'stretch'
                          }}
                          textAlign='left'
                        >
                          Business Title
                        </VegaFont>

                        <VegaBox
                          padding={{
                            top: '0',
                            right: '0',
                            bottom: '0',
                            left: '0'
                          }}
                          corners='rounded-none'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-p2-short'
                            style={{
                              verticalAlign: 'bottom',
                              alignSelf: 'stretch'
                            }}
                          >
                            { businessTitleSource.find((i) => userInfo.titleId === i.id)?.displayName ?? '' }
                          </VegaFont>
                        </VegaBox>
                      </VegaFlex>
                    </VegaFlex>
                  </VegaGrid>
                </VegaFlex>
                <VegaFlex
                  id='user-info-editable'
                  direction='col'
                  alignItems='stretch'
                  justifyContent='center'
                  gap='size-12'
                  style={{
                    display: isEditingUserInfo ? 'flex' : 'none',
                    minWidth: '70%'
                  }}
                >
                  <VegaForm style={{ width: '100%' }} ref={formRef}>
                    <VegaFont
                      color='text-primary'
                      variant='font-h5'
                      style={{ verticalAlign: 'top', alignSelf: 'stretch' }}
                    >
                      {userInfo?.name ?? ''}
                    </VegaFont>
                    <VegaGrid
                      gap='size-20'
                      column='3-auto'
                      row='3-auto'
                      style={{ marginTop: '12px' }}
                    >
                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-map-marked-alt'
                          color='text-secondary'
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Location
                          </VegaFont>
                          <VegaInput
                            id='user-location'
                            type='text'
                            value={userInfo?.locationName ?? ''}
                            placeholder='Enter your location'
                            width='100%'
                            disabled={true}
                            size='small'
                          ></VegaInput>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-phone'
                          color='text-secondary'
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Phone
                          </VegaFont>
                          <VegaInput
                            id='user-phone'
                            type='text'
                            value={phone}
                            maxLength={15}
                            data-vega-form={'userPhone'}
                            autoValidation={isSubmitInvalid}
                            validationRules={[phoneNumberValidationRule]}
                            placeholder='Enter your phone number'
                            onVegaChange={(e) => {
                              setPhone(e.target.value);
                            }}
                            errorMessage={isSubmitInvalid && phone.trim() !== '' && !validatePhone(phone) ? 'Please enter a valid phone number.' : ''}
                            size='small'
                          ></VegaInput>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-id-card-clip'
                          color='text-secondary'
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Employee ID
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInput
                              id='user-employee-id'
                              type='email'
                              value={employeeId}
                              placeholder='Enter your employee Id'
                              width='100%'
                              size='small'
                              disabled={disableEdit}
                              onVegaChange={(e) => {
                                setEmployeeId(e.target.value);
                              }}
                            ></VegaInput>
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-at'
                          color='text-secondary'
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Primary Email
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInput
                              id='user-primary-email'
                              type='email'
                              value={userInfo?.email ?? ''}
                              placeholder='Enter your primary email'
                              width='100%'
                              disabled={true}
                              size='small'
                            ></VegaInput>
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-at'
                          color='text-secondary'
                        ></VegaIcon>

                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Secondary Email
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInput
                              id='user-secondary-email'
                              type='email'
                              data-vega-form={'secondaryEmail'}
                              autoValidation={isSubmitInvalid}
                              errorMessage={isSubmitInvalid && secondaryEmail.trim() !== '' && !validateEmail(secondaryEmail) ? 'Please enter a valid email address.' : ''}
                              value={secondaryEmail}
                              maxLength={50}
                              onVegaChange={(e) => {
                                setSecondaryEmail(e.target.value);
                              }}
                              placeholder='Enter your secondary email'
                              size='small'
                            ></VegaInput>
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-people-roof'
                          color='text-secondary'
                          style={{ width: '18px' }}
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Line Manager
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInputSelect
                              id='user-manager-name'
                              value={managerId}
                              source={userList}
                              maxLength={16}
                              disabled={disableEdit}
                              onVegaChange={(e) => onChangeManagerId(e.target.value)}
                              placeholder='select your line manager'
                              style={{ minWidth: '290px' }}
                              size='small'
                              vegaDropdownProps={{ searchable: true }}
                            />
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-user-large'
                          color='text-secondary'
                          style={{ width: '18px' }}
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Project Role
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInputSelect
                              id='user-manager-name'
                              value={roleId}
                              source={role}
                              maxLength={16}
                              disabled={disableEdit}
                              onVegaChange={(e) => onChangeRoleId(e.target.value)}
                              placeholder='select your line manager'
                              style={{ minWidth: '290px' }}
                              size='small'
                              vegaDropdownProps={{ searchable: true }}
                            />
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-screen-users'
                          color='text-secondary'
                          style={{ width: '18px' }}
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Position Classification
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInputSelect
                              id='user-manager-name'
                              value={positionCategoryId}
                              source={positionCategories}
                              maxLength={16}
                              disabled={disableEdit}
                              onVegaChange={(e) => onChangePositionCategoryId(e.target.value)}
                              placeholder='select your line manager'
                              style={{ minWidth: '290px' }}
                              size='small'
                              vegaDropdownProps={{ searchable: true }}
                            />
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-id-card'
                          color='text-secondary'
                          style={{ width: '18px' }}
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Business Title
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInputSelect
                              id='user-manager-name'
                              value={titleId}
                              source={businessTitleSource}
                              maxLength={16}
                              disabled={disableEdit}
                              onVegaChange={(e) => onChangeTitleId(e.target.value)}
                              placeholder='select your line manager'
                              style={{ minWidth: '290px' }}
                              size='small'
                              vegaDropdownProps={{ searchable: true }}
                            />
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>

                      <VegaFlex
                        direction='row'
                        alignItems='start'
                        justifyContent='start'
                        gap='size-12'
                      >
                        <VegaIcon
                          size='size-16'
                          icon='far fa-signature'
                          color='text-secondary'
                          style={{ width: '18px' }}
                        ></VegaIcon>
                        <VegaFlex
                          direction='col'
                          alignItems='stretch'
                          justifyContent='center'
                          gap='size-8'
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-field-label-sm'
                            style={{
                              display: 'block',
                              verticalAlign: 'middle',
                              alignSelf: 'stretch'
                            }}
                            textAlign='left'
                          >
                            Native Name
                          </VegaFont>
                          <VegaBox
                            padding={{
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0'
                            }}
                            corners='rounded-none'
                          >
                            <VegaInput
                              id='user-native-name'
                              type='text'
                              value={nativeName}
                              maxLength={16}
                              onVegaChange={(e) => setNativeName(e.target.value)}
                              placeholder='Enter your native name'
                              width='100%'
                              size='small'
                            ></VegaInput>
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>
                    </VegaGrid>
                  </VegaForm>
                </VegaFlex>
              </VegaFlex>
              <VegaChip
                style={{ display: isEditingUserInfo ? 'none' : 'flex' }}
                id='user-info-edit-button'
                iconAlign='right'
                showCloseIcon='false'
                clickable={true}
                icon='fa-solid fa-pen-to-square'
                textColor='text-sidebar-link-hover'
                size='default'
                text='Edit'
                variant='outlined'
                onVegaClick={() => setIsEditingUserInfo(true)}
              ></VegaChip>
            </VegaFlex>
            <VegaFlex
                id='user-info-edit-actions'
                alignItems="end"
                justifyContent="end"
                gap="size-12"
                style={{
                  display: isEditingUserInfo ? 'flex' : 'none',
                  flex: 1
                }}
              >
                <VegaButton
                  id='user-info-cancel'
                  variant='secondary'
                  size='small'
                  onVegaClick={() => {
                    formRef.current.setValue({ 'userPhone': userInfo?.phone ? userInfo.phone.trim() : '' });
                    formRef.current.setValue({ 'secondaryEmail': userInfo?.secondaryEmail ? userInfo.secondaryEmail.trim() : '' });
                    if (userInfo !== null) {
                      setPhone(userInfo?.phone ? userInfo.phone.trim() : '');
                      setSecondaryEmail(userInfo?.secondaryEmail ? userInfo.secondaryEmail.trim() : '');
                      setNativeName(userInfo?.nativeName ? userInfo.nativeName.trim() : '');
                      setEmployeeId(userInfo?.employeeId ? userInfo.employeeId : '');
                    }
                    resetUserIcon();
                    setIsEditingUserInfo(false);
                    setIsSubmitInvalid(false);
                  }}
                >
                  Cancel
                </VegaButton>
                <VegaButton
                  id='user-info-save'
                  variant='primary'
                  size='small'
                  onVegaClick={() => {
                    setIsSubmitInvalid(true);
                    formRef.current.valid().then((res) => {
                      if (res.isValid) {
                        _onSave();
                      }
                    });
                  }}
                >
                  Save
                </VegaButton>
            </VegaFlex>
          </VegaFlex>
        </VegaCard>
        <VegaBox
          padding='0'
          corners='rounded-none'
          className='employee-information'
        >
          <VegaCard
            padding='size-24'
            backgroundColor='bg-primary'
          >
            <VegaFlex
              direction='col'
              alignItems='stretch'
              justifyContent='start'
              gap='size-24'
            >
              <VegaFlex
                direction='col'
                alignItems='stretch'
                justifyContent='start'
                gap='size-24'
              >
                <VegaFlex
                  direction='row'
                  alignItems='center'
                  justifyContent='space-between'
                  gap='size-32'
                >
                  <VegaFont
                    color='text-primary'
                    variant='font-h5'
                    style={{ verticalAlign: 'top', alignSelf: 'stretch' }}
                  >
                    Employee Information
                  </VegaFont>
                </VegaFlex>
                <VegaGrid
                  gap='size-20'
                  column='4-auto'
                  row='1-auto'
                >
                  <VegaFlex
                    direction='row'
                    alignItems='stretch'
                    justifyContent='start'
                    gap='size-12'
                  >
                    <VegaIcon
                      size='size-16'
                      icon='far fa-user-tag'
                      color='text-secondary'
                    ></VegaIcon>
                    <VegaFlex
                      direction='col'
                      alignItems='stretch'
                      justifyContent='start'
                      gap='size-8'
                    >
                      <VegaFont
                        color='text-primary'
                        variant='font-field-label-sm'
                        style={{
                          display: 'block',
                          verticalAlign: 'middle',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        Employee Type
                      </VegaFont>
                      <VegaFont
                        color='text-primary'
                        variant='font-p2-short'
                        style={{
                          display: 'block',
                          verticalAlign: 'bottom',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        { mapemployeeTypeOptions[userInfo?.employeeType] ?? '' }
                      </VegaFont>
                    </VegaFlex>
                  </VegaFlex>
                  <VegaFlex
                    direction='row'
                    alignItems='stretch'
                    justifyContent='start'
                    gap='size-12'
                  >
                    <VegaIcon
                      size='size-16'
                      icon='far fa-money-check-dollar-pen'
                      color='text-secondary'
                    ></VegaIcon>
                    <VegaFlex
                      direction='col'
                      alignItems='stretch'
                      justifyContent='start'
                      gap='size-8'
                    >
                      <VegaFont
                        color='text-primary'
                        variant='font-field-label-sm'
                        style={{
                          display: 'block',
                          verticalAlign: 'middle',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        Cost Center ID
                      </VegaFont>
                      <VegaFont
                        color='text-primary'
                        variant='font-p2-short'
                        style={{
                          display: 'block',
                          verticalAlign: 'bottom',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        { userInfo?.costCenterId ?? '' }
                      </VegaFont>
                    </VegaFlex>
                  </VegaFlex>
                  <VegaFlex
                    direction='row'
                    alignItems='stretch'
                    justifyContent='start'
                    gap='size-12'
                  >
                    <VegaIcon
                      size='size-16'
                      icon='far fa-calendar-range'
                      color='text-secondary'
                    ></VegaIcon>
                    <VegaFlex
                      direction='col'
                      alignItems='stretch'
                      justifyContent='start'
                      gap='size-8'
                    >
                      <VegaFont
                        color='text-primary'
                        variant='font-field-label-sm'
                        style={{
                          display: 'block',
                          verticalAlign: 'middle',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        Original Hire Date
                      </VegaFont>
                      <VegaFont
                        color='text-primary'
                        variant='font-p2-short'
                        style={{
                          display: 'block',
                          verticalAlign: 'bottom',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        { formatDate(userInfo?.originalHireDate) ?? '' }
                      </VegaFont>
                    </VegaFlex>
                  </VegaFlex>
                  <VegaFlex
                    direction='row'
                    alignItems='stretch'
                    justifyContent='start'
                    gap='size-12'
                  >
                    <VegaIcon
                      size='size-16'
                      icon='far fa-calendar-range'
                      color='text-secondary'
                    ></VegaIcon>
                    <VegaFlex
                      direction='col'
                      alignItems='stretch'
                      justifyContent='start'
                      gap='size-8'
                    >
                      <VegaFont
                        color='text-primary'
                        variant='font-field-label-sm'
                        style={{
                          display: 'block',
                          verticalAlign: 'middle',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        Length of Service
                      </VegaFont>
                      <VegaFont
                        color='text-primary'
                        variant='font-p2-short'
                        style={{
                          display: 'block',
                          verticalAlign: 'bottom',
                          alignSelf: 'stretch'
                        }}
                        textAlign='left'
                      >
                        { userInfo?.lengthOfService ?? '' }
                      </VegaFont>
                    </VegaFlex>
                  </VegaFlex>
                </VegaGrid>
              </VegaFlex>
            </VegaFlex>
          </VegaCard>
        </VegaBox>

        <VegaCard
          className='business-information'
          padding='size-24'
          backgroundColor='bg-primary'
        >
          <VegaFlex
            direction='col'
            alignItems='stretch'
            justifyContent='start'
            gap='size-24'
          >
            <VegaFlex
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              gap='size-32'
            >
              <VegaFont
                color='text-primary'
                variant='font-h5'
                style={{ verticalAlign: 'top', alignSelf: 'stretch' }}
              >
                Business Information
              </VegaFont>
              <VegaChip
                style={{ display: disableEdit ? 'none' : 'flex' }}
                id='business-information-edit-button'
                iconAlign='right'
                showCloseIcon='false'
                clickable={true}
                icon='fa-solid fa-pen-to-square'
                textColor='text-sidebar-link-hover'
                size='default'
                text='Edit'
                variant='outlined'
                onVegaClick={showUpdateBusinessInformationModal}
              ></VegaChip>
            </VegaFlex>
            <div
              className="business-grid-wrapper"
              style={userInfo?.userAllocations?.length > 9 ? { paddingRight: '8px' } : {}}
            >
              <VegaFlex
                className="business-grid"
                direction='row'
                alignItems='stretch'
                justifyContent='start'
                gap='size-20'
                flexWrap='wrap'
              >
                {userInfo?.userAllocations?.map((item, index) => (
                  <VegaFlex
                    className='business-item-out'
                    direction='col'
                    alignItems='stretch'
                    justifyContent='center'
                    key={index}
                    style={{ width: '280px' }}
                  >
                    <VegaBox
                      className='business-item-top'
                      padding='0'
                      corners='rounded-none'
                      style={{ background: item.isPrimary ? '#806BFF' : '#FF9571' }}
                    >
                    </VegaBox>
                    <VegaFlex
                      className='business-item'
                      direction='col'
                      alignItems='stretch'
                      justifyContent='center'
                      gap='size-12'
                    >
                      <VegaFlex
                        direction='row'
                        alignItems='end'
                        justifyContent='space-between'
                        gap='size-4'
                      >
                        <VegaBox
                          padding='0'
                          corners='rounded-none'
                          style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: '160px'
                          }}
                        >
                          <VegaFont
                            color='text-primary'
                            variant='font-btn-label'
                            style={{
                              verticalAlign: 'middle',
                              alignSelf: 'stretch',
                              lineHeight: '18px',
                              size: '14px'
                            }}
                          >
                            {item.projectName || <span style={{ opacity: 0 }}>Placeholder</span>}
                          </VegaFont>
                        </VegaBox>
                        <VegaBox
                          padding='0'
                          corners='rounded-none'
                        >
                          <VegaBox
                            padding='0'
                            corners='rounded-none'
                          >
                            <VegaFont
                              variant='font-btn-label-sm'
                              style={{
                                verticalAlign: 'middle',
                                alignSelf: 'stretch',
                                lineHeight: '18px',
                                size: '14px'
                              }}
                            >
                              {(() => {
                                const alloc = Number(item.allocation) || 0;
                                const rounded = Math.round((alloc * 100) * 100) / 100;
                                const roundedStr = rounded.toFixed(2);
                                const display = roundedStr.endsWith('.00') ? String(Math.round(rounded)) : roundedStr.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
                                return `${display}%${item.isPrimary ? ' (Primary)' : ''}`;
                              })()}
                            </VegaFont>
                          </VegaBox>
                        </VegaBox>
                      </VegaFlex>
                      <VegaFlex
                        direction='row'
                        alignItems='end'
                        justifyContent='space-between'
                        gap='size-4'
                      >
                        <VegaFlex
                          direction='col'
                          alignItems='start'
                          justifyContent='start'
                          gap='size-4'
                        >
                          <VegaBox
                            padding='0'
                            corners='rounded-none'
                          >
                            <VegaFont
                              color='text-primary'
                              variant='font-field-label-sm'
                              style={{
                                verticalAlign: 'middle',
                                alignSelf: 'end',
                                lineHeight: '16px',
                                size: '14px'
                              }}
                            >
                              {item.marketCode?.name || <span style={{ opacity: 0 }}>Placeholder</span>}
                            </VegaFont>
                          </VegaBox>
                        </VegaFlex>
                      </VegaFlex>
                    </VegaFlex>
                  </VegaFlex>
                ))}
              </VegaFlex>
            </div>
          </VegaFlex>
        </VegaCard>

        <VegaCard
          className='access-permission'
          padding='size-24'
          backgroundColor='bg-primary'
        >
          <VegaFlex
            direction='col'
            alignItems='stretch'
            justifyContent='start'
            gap='size-24'
          >
            <VegaFlex
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              gap='size-32'
            >
              <VegaFont
                color='text-primary'
                variant='font-h5'
                style={{ verticalAlign: 'top', alignSelf: 'stretch' }}
              >
                Access Permission
              </VegaFont>
              <VegaButtonLink
                icon="fa fa-plus"
                onVegaClick={() => openAddAndUpdateAccessPermissionModal()}
                style={{ display: disableEdit ? 'none' : 'flex' }}
                >
                Add New
              </VegaButtonLink>
            </VegaFlex>
            <div
              className="business-grid-wrapper"
              style={userInfo?.userAllocations?.length > 9 ? { paddingRight: '8px' } : {}}
            >
              <VegaFlex
                className="business-grid"
                direction='row'
                alignItems='stretch'
                justifyContent='start'
                gap='size-20'
                flexWrap='wrap'
              >
                {projectRolePermissions?.map((item, index) => (
                  <VegaFlex
                    className='business-item-out'
                    direction='col'
                    alignItems='stretch'
                    justifyContent='center'
                    key={index}
                    style={{ width: '280px' }}
                  >
                    <VegaBox
                      className='business-item-top'
                      padding='0'
                      corners='rounded-none'
                      style={{ background: '#00BBFF' }}
                    >
                    </VegaBox>
                    <VegaFlex
                      className='access-permission-item'
                      key={index}
                      direction='col'
                      alignItems='stretch'
                      justifyContent='center'
                      gap='size-12'
                    >
                      <VegaBox
                        padding='0'
                        corners='rounded-none'
                      >
                        <VegaFont
                          color='text-primary'
                          variant='font-btn-label'
                          style={{
                            verticalAlign: 'middle',
                            alignSelf: 'stretch',
                            minHeight: '24px',
                            lineHeight: '18px',
                            size: '14px'
                          }}
                        >
                          {projectAlls.find((i) => item.projectId === i.id)?.displayName || <span style={{ opacity: 0 }}>Placeholder</span>}
                        </VegaFont>
                      </VegaBox>
                      <VegaFlex
                        direction='row'
                        alignItems='end'
                        justifyContent='space-between'
                        gap='size-4'
                      >
                        <VegaFlex
                          direction='col'
                          alignItems='start'
                          justifyContent='start'
                          gap='size-4'
                        >
                          <VegaBox
                            padding='0'
                            corners='rounded-none'
                          >
                            <VegaFont
                              color='text-primary'
                              variant='font-field-label-sm'
                              style={{
                                verticalAlign: 'middle',
                                alignSelf: 'center',
                                lineHeight: '18px',
                                size: '14px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                width: '100%'
                              }}
                            >
                              {getRoleName(item.roleId) || <span style={{ opacity: 0 }}>Placeholder</span>}
                            </VegaFont>
                          </VegaBox>
                          <VegaBox
                            padding='0'
                            corners='rounded-none'
                          >
                            <VegaFont
                              color='text-primary'
                              variant='font-field-label-sm'
                              style={{
                                verticalAlign: 'middle',
                                alignSelf: 'end',
                                lineHeight: '18px',
                                size: '14px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                width: '100%'
                              }}
                            >
                              {item.scrumTeamName || <span style={{ opacity: 0 }}>Placeholder</span>}
                            </VegaFont>
                          </VegaBox>
                        </VegaFlex>
                        <VegaFlex
                          direction='row'
                          alignItems='end'
                          justifyContent='space-between'
                          gap='size-4'
                        >
                          <VegaButtonCircle
                            size="default"
                            disabled="false"
                            danger="false"
                            variant="icon-only"
                            icon="far fa-trash-can"
                            iconColor="text-sidebar-link-hover"
                            style={{ display: disableEdit ? 'none' : 'flex' }}
                            onVegaClick={() => openAccessPermissionConfrimModal(item)}
                          ></VegaButtonCircle>
                        </VegaFlex>
                      </VegaFlex>
                    </VegaFlex>
                  </VegaFlex>
                ))}
              </VegaFlex>
            </div>
          </VegaFlex>
        </VegaCard>
      </VegaFlex>

      <UserProfileAddAndUpdateAccessPermissionModal
        open={addAndUpdateModal}
        onClose={closeAddAndUpdateAccessPermissionModal}
        projects={projects || []}
        projectRolesDataSource={projectRolesDataSource}
        userInfo={userInfo}
        fetchUserRolePermission={fetchUserRolePermission}
        projectRolePermissions={projectRolePermissions}
      />
      <UserProfileUpdateBusinessInformationModal
        open={openUpdateBusinessInformationModal}
        onClose={closeUpdateBusinessInformationModal}
        scrumTeams={scrumTeams || []}
        userAllocations={userAllocations}
        projects={projects}
        userId={userId}
        loadUserInfo={loadUserInfo}
        />

      <VegaModal
        open={accessPermissionConfirmModel}
        id={'access-permission-confirm-modal'}
        size={'480'}
        padding="size-24"
        backdrop={'static'}
        onVegaClose={closeAccessPermissionConfrimModal}
        // modalTitle = "All the changes will be effected once submitted."
      >
        <div slot = "modal-title">
          Remove Access Permission
        </div>
        <div slot="modal-content">
          Do you want to remove the Access Permission?
        </div>
        <div slot="modal-footer" className="accessPermissionfooter">
          <div className='v-pt-size-4 v-pb-size-2 v--mr-size-16'>
            <VegaFlex
              direction={'row'}
              gap={'size-12'}
              margin={'size-16'}
              justifyContent={'end'}
            >
              <VegaButton
                label={'Cancel'}
                size={'small'}
                variant={'secondary'}
                onVegaClick={closeAccessPermissionConfrimModal}
              ></VegaButton>
              <VegaButton
                label={'Romove'}
                danger={true}
                size={'small'}
                disabled={deletePermissionDisabled}
                onVegaClick={() => {
                  deleteAccessPermission();
                }}
              ></VegaButton>
            </VegaFlex>
          </div>
        </div>
      </VegaModal>
    </>
  );
};

UserProfile.propTypes = {
  sourceData: PropTypes.object,
  userInfo: PropTypes.object,
  loadUserInfoAvatar: PropTypes.func,
  isRedirect: PropTypes.bool
};

export default UserProfile;
